export const BlockBorder = () => (
    <hr className="block-border" />
);